// assets
import {
  IconDashboard,
  IconArticle,
  IconAdjustments,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconReceiptRefund,
  IconCpu,
  IconRocket,
  IconShieldLock,
  IconPackage,
  IconChartBar,
  IconTicket,
  IconGift,
  IconSpeakerphone
} from '@tabler/icons-react';

// constant
const icons = {
  IconDashboard,
  IconArticle,
  IconAdjustments,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconReceiptRefund,
  IconCpu,
  IconRocket,
  IconShieldLock,
  IconPackage,
  IconChartBar,
  IconTicket,
  IconGift,
  IconSpeakerphone
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '总览',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'config',
      title: '配置',
      type: 'item',
      url: '/panel/model-config',
      icon: icons.IconCpu,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'account',
      title: '账户管理',
      type: 'collapse',
      icon: icons.IconUser,
      isAdmin: true,
      children: [
        {
          id: 'user',
          title: '用户管理',
          type: 'item',
          url: '/panel/user',
          icon: icons.IconUser,
          breadcrumbs: false,
          isAdmin: true
        }
      ]
    },
    {
      id: 'trade',
      title: '交易中心',
      type: 'collapse',
      icon: icons.IconGardenCart,
      isAdmin: true,
      children: [
        {
          id: 'product-management',
          title: '商品管理',
          type: 'item',
          url: '/panel/product-management',
          icon: icons.IconPackage,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'order',
          title: '订单管理',
          type: 'item',
          url: '/panel/order',
          icon: icons.IconReceiptRefund,
          breadcrumbs: false,
          isAdmin: true
        }
      ]
    },
    {
      id: 'data-board',
      title: '数据看板',
      type: 'collapse',
      icon: icons.IconChartBar,
      isAdmin: true,
      children: [
        {
          id: 'respal-dashboard',
          title: 'Respal看板',
          type: 'item',
          url: '/panel/respal-dashboard',
          icon: icons.IconChartBar,
          breadcrumbs: false,
          isAdmin: true
        }
      ]
    },
    {
      id: 'operation',
      title: '运营工具',
      type: 'collapse',
      icon: icons.IconRocket,
      isAdmin: true,
      children: [
        {
          id: 'version-release',
          title: '版本发布',
          type: 'item',
          url: '/panel/version-release',
          icon: icons.IconRocket,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'influencer-code',
          title: '兑换码',
          type: 'item',
          url: '/panel/influencer-code',
          icon: icons.IconTicket,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'activity',
          title: '活动管理',
          type: 'item',
          url: '/panel/activity',
          icon: icons.IconGift,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'user-crowd',
          title: '用户分群',
          type: 'item',
          url: '/panel/user-crowd',
          icon: icons.IconUserScan,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'notification',
          title: '通知管理',
          type: 'item',
          url: '/panel/notification',
          icon: icons.IconSpeakerphone,
          breadcrumbs: false,
          isAdmin: true
        }
      ]
    },
    {
      id: 'log',
      title: '日志详情',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false
    },
    {
      id: 'setting-group',
      title: '设置',
      type: 'collapse',
      icon: icons.IconAdjustments,
      children: [
        {
          id: 'setting',
          title: '系统设置',
          type: 'item',
          url: '/panel/setting',
          icon: icons.IconAdjustments,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'admin-permissions',
          title: '后台权限',
          type: 'item',
          url: '/panel/admin-permissions',
          icon: icons.IconShieldLock,
          breadcrumbs: false,
          isAdmin: true
        },
        {
          id: 'profile',
          title: '我的',
          type: 'item',
          url: '/panel/profile',
          icon: icons.IconUserScan,
          breadcrumbs: false,
          isAdmin: false
        }
      ]
    }
  ]
};

export default panel;
